import { render } from "./BlankLayout.vue?vue&type=template&id=24532c6c&ts=true"
import script from "./BlankLayout.vue?vue&type=script&lang=ts"
export * from "./BlankLayout.vue?vue&type=script&lang=ts"

import exportComponent from "F:\\Waddecar Media\\Development\\Forms\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__